// Estado Beta de una guia y su disclaimer. VIVA-1248 / VIVA-1165.
//
// TODA la lectura del estado Beta vive aqui a proposito. El campo YA LLEGA y se
// llama `isBeta`: comprobado el 22/09/2026 contra PRE, lo devuelven tanto
// `obtener/catalogo-guias` (15 campos) como `obtener/detalle-guia` (19). No lo
// devuelve `obtener/contenido-guia`, y eso es correcto, no un hueco: el
// distintivo es de la tarjeta del catalogo, no de la guia ya abierta.
//
// La lista de nombres alternativos se conserva por si el serializador cambia de
// convencion; el que manda hoy es el primero. Sigue en un solo archivo para que,
// si backend lo renombra, corregirlo sea tocar esta lista y nada mas.
const BETA_FIELDS = [
  "isBeta",
  "IsBeta",
  "esBeta",
  "EsBeta",
  "beta",
  "Beta",
  "isBetaVersion",
  "IsBetaVersion",
];

// Solo un true de verdad marca Beta. Un `null`, un `0` o la ausencia del campo
// —que es lo que pasa hoy— significan "no es Beta", nunca "quiza".
export const isGuideBeta = (guide) => {
  if (!guide) return false;

  return BETA_FIELDS.some((field) => {
    const value = guide[field];
    return value === true || value === "true" || value === 1;
  });
};

// Clave del disclaimer en el esquema remoto (/api/lang/sch).
//
// Sigue VACIA: al 22/09/2026 el esquema de pre no tiene ninguna clave del
// disclaimer (1388 claves en ES y EN, ninguna habla de Beta ni de
// actualizaciones), aunque VIVA-1247 figura en Hecho. El dia que se publique,
// se escribe su codigo aqui y el texto del esquema desplaza al provisional.
export const GUIDE_BETA_DISCLAIMER_TEXT_KEY = "";

// ⚠️ TEXTO PROVISIONAL — NO APROBADO POR LEGAL (VIVA-1220).
//
// Decision del 22/09/2026 (VIVA-1165): el disclaimer tiene que mostrarse antes
// del flujo de pago, y mientras el texto oficial no exista se usa este
// respaldo. Cubre los cuatro puntos del criterio de aceptacion y dice "la guia
// y sus actualizaciones", no "esta version" (nota de la epica VIVA-1148).
//
// No es la redaccion final: acompana una venta y contiene una promesa de
// acceso. El esquema SIEMPRE gana; en cuanto la clave exista, esto deja de
// usarse solo. Retirarlo es borrar este objeto y su prueba.
export const GUIDE_BETA_DISCLAIMER_FALLBACK = {
  es:
    "Esta guía está en versión Beta y seguirá creciendo. El precio reducido corresponde a esta etapa. " +
    "Al comprarla tendrás acceso a la guía y a sus actualizaciones sin pagar de nuevo. " +
    "Tus comentarios nos ayudan a mejorarla: compártelos con nosotros.",
  en:
    "This guide is in Beta and will keep growing. The reduced price reflects this stage. " +
    "When you buy it, you get access to the guide and its updates without paying again. " +
    "Your feedback helps us improve it, so please share it with us.",
};

// Clave del distintivo Beta —la etiqueta corta de la tarjeta— en el esquema
// remoto. VIVA-1246.
//
// Tambien vacia, y por una razon que el ticket deja escrita: "mientras la clave
// no exista, el distintivo se puede desarrollar contra un respaldo local, pero
// no se entrega asi: seria repetir la deuda que quedo abierta en VIVA-1027 con
// las categorias de evento". La publica VIVA-1245.
export const GUIDE_BETA_BADGE_TEXT_KEY = "";

// El texto sale SIEMPRE del esquema, que ya llega en el idioma activo —de eso se
// encarga LayoutTemplate al pedirlo por idioma—, asi que el criterio del idioma
// se cumple sin nada extra. Si la clave no esta publicada, se devuelve vacio y
// quien llama no pinta nada.
const readSchemeText = (texts, textKey) => {
  if (!textKey) return "";

  const value = texts?.[textKey];
  return typeof value === "string" && value.trim() !== "" ? value : "";
};

// El esquema primero; si no trae la clave, el texto provisional del idioma
// activo.
export const resolveGuideBetaDisclaimer = (
  texts,
  textKey = GUIDE_BETA_DISCLAIMER_TEXT_KEY,
  isEnglish = false
) =>
  readSchemeText(texts, textKey) ||
  (isEnglish ? GUIDE_BETA_DISCLAIMER_FALLBACK.en : GUIDE_BETA_DISCLAIMER_FALLBACK.es);

// Respaldo local del distintivo, mientras VIVA-1245 publica la clave.
//
// El ticket VIVA-1246 pedia NO entregar con respaldo local, para no repetir la
// deuda de VIVA-1027 con las categorias de evento. Se entrega asi por decision
// del 18/09/2026, y la diferencia con aquel caso es que aqui no hay traduccion
// que inventar: "Beta" se escribe igual en espanol y en ingles, asi que el
// respaldo no puede quedar mal traducido ni contradecir al texto que publique
// backend. Se mantiene la estructura por idioma porque el dia que el PO quiera
// "Version Beta" / "Beta version" ya no dara igual.
//
// El esquema SIEMPRE gana: en cuanto la clave exista, esto deja de usarse solo.
export const GUIDE_BETA_BADGE_FALLBACK = { es: "Beta", en: "Beta" };

export const resolveGuideBetaBadge = (
  texts,
  textKey = GUIDE_BETA_BADGE_TEXT_KEY,
  isEnglish = false
) =>
  readSchemeText(texts, textKey) ||
  (isEnglish ? GUIDE_BETA_BADGE_FALLBACK.en : GUIDE_BETA_BADGE_FALLBACK.es);
